import { PROVIDER_PATHS } from "../../../../../constants/paths";

/**
 * Centralised navigation targets for the claim screens.
 *
 * The Billing area derives its active tab purely from the URL: the index route
 * `/app/provider/billing/` is the "Ready For Billing" (RFB) tab and
 * `/app/provider/billing/claims` is the Claim tab. Claim create/submit flows
 * used to fall back to the index route (RFB), which is the wrong tab — the
 * partial / submitted claim actually lives on the Claim tab.
 */

/** Billing → Claim tab (where created / updated claims are listed). */
export const CLAIM_TAB_PATH = PROVIDER_PATHS.CLAIMS;

